//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueContentLoader from "vue-content-loading";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AppAutomationDetailsLoader",
  components: {
    VueContentLoader
  }
});